import { render, staticRenderFns } from "./ai.vue?vue&type=template&id=e1f60e9e&scoped=true"
import script from "./ai.vue?vue&type=script&lang=js"
export * from "./ai.vue?vue&type=script&lang=js"
import style0 from "./ai.vue?vue&type=style&index=0&id=e1f60e9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f60e9e",
  null
  
)

export default component.exports